/* eslint-disable max-len */
import React, { useEffect, useState, useRef } from 'react'
import classNames from 'classnames'
import PricingCard from './card'

const PricingBlock = () => {
   const [visible, setVisible] = useState(false)
   const containerRef = useRef(null)

   useEffect(() => {
      const observer = new IntersectionObserver(
         ([entry]) => {
            if (entry.isIntersecting) {
               setVisible(true)
            } else {
               setVisible(false)
            }
         },
         {
            threshold: 0.2,
            rootMargin: '0px'
         }
      )

      if (containerRef.current) {
         observer.observe(containerRef.current)
      }

      return () => {
         if (containerRef.current) {
            observer.disconnect()
         }
      }
   }, [])

   return (
      <div className="w-full border-t border-solid border-white/20">
         <div className="communities-content-wrapper">
            <div className="w-full">
               <div className="w-full md:max-w-xl mx-auto text-white md:text-center mt-32 mb-16 md:mb-16">
                  <div className="text-[36px] sm:text-[40px] md:text-[40px] lg:text-[38px] xl:text-[44px] leading-[1.1] font-serif-title tracking-tighter font-medium xl:mt-8 mb-4">
                     Pricing
                  </div>
                  <div className="text-base opacity-60">
                     Whether you&apos;re building a community from the ground up or are connecting
                     millions, we support organizations and communities of all sizes. Get in
                     touch with us to see how Communities can work for you.
                  </div>
                  {/* <div className="text-base uppercase font-semibold tracking-tight text-white/80">
                     Pricing
                  </div>
                  <div
                     className="text-5xl font-medium tracking-tight text-white mt-4"
                     style={{ fontFamily: 'garamond' }}>
                     Choose your plan
                  </div> */}
               </div>
               <div
                  ref={containerRef}
                  className={classNames(
                     'md:max-w-none mx-auto grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-0 bg-white/10 rounded-3xl mb-16 transition-all duration-700',
                     visible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'
                  )}>
                  {/* Basic Plan */}
                  <PricingCard
                     title="Basic"
                     subtitle="For getting started "
                     price="$199"
                     features={[
                        'Up to 1000 Community members',
                        'Events, Groups, Discussions, Messaging, Payments, Member Profiles, and more',
                        'Basic analytics',
                        'Community forums',
                        'up to 100GB of storage',
                        'Email notifications and digests (up to 20,000 emails per month)',
                        'Email support',
                        'Automated backups'
                     ]}
                  />
                  <PricingCard
                     title="Pro"
                     subtitle="For growing communities"
                     price="$399"
                     features={[
                        'Up to 5000 Community members',
                        'Everything included in Basic',
                        'Custom branding, theming and design',
                        'Multi-tenant integrated Communities',
                        'up to 500GB of storage',
                        'Email notifications and digests (up to 100,000 emails per month)',
                        'Priority support'
                     ]}
                  />
                  <PricingCard
                     title="Enterprise"
                     subtitle="For large-scale and custom builds"
                     price="Custom"
                     features={[
                        'Unlimited Community members',
                        'Everything included in Pro',
                        'Custom features and integrations',
                        'Training and live event support',
                        'Advanced analytics',
                        'Data migration from other platforms',
                        '+1TB of storage',
                        'Email notifications and digests (over 100,000 emails per month)'
                     ]}
                  />
               </div>
            </div>
         </div>
      </div>
   )
}

export default PricingBlock
